import { useState } from "react"
import { IoCloseSharp } from "react-icons/io5";


export default function Footer() {

    const [Policy, setPolicy] = useState(false)

    const ShowPolicy = () => {
        setPolicy(true)

    }

    const closePolicy = () => {
        setPolicy(false)
    }

    return (
        <div>
            <div className="bg-gray-100 dark:bg-black dark:border-t w-full px-3 mb-16 md:mb-0 md:px-4 py-6 md:py-10 md:p-10 flex justify-between">

                <p className="text-xs md:text-sm dark:text-white">Developed with love by Besmillah Hakimi © {new Date().getFullYear()}</p>
                <p className="text-xs lg:text-sm dark:text-white hover:text-primary hover:cursor-pointer ease-in duration-150" onClick={ShowPolicy}>Privacy Policy</p>

            </div>

            {/* policy  */}
            {Policy &&
                <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-80 flex items-center z-50">
                    <IoCloseSharp onClick={closePolicy} className="absolute top-3 right-3 md:right-8 w-7 h-7 text-white p-1 border border-primary rounded-md hover:cursor-pointer hover:bg-primary ease-out duration-200" />

                    <div className="custom-scrollbar bg-white h-fit w-[85%] text-sm my-30 md:h-[90%] md:w-[60%] mx-auto p-4 md:p-8 rounded-md overflow-scroll">
                        <h1 className="text-center font-bold mb-4">Privacy Policy</h1>
                        <p>Last updated: September 03, 2025</p>
                        <p>
                            This portfolio website only collects your email address when you choose to contact me.
                            Your email will only be used to respond to your inquiry and will not be shared with third parties.
                        </p>

                        <p>
                            If you have any questions, feel free to reach me at
                            <a href="mailto:hakimi.work2025@gmail.com" className="text-primary"> hakimi.work2025@gmail.com</a>.
                        </p>
                    </div>


                </div>
            }
        </div>
    )
}